import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "map-elem-info junkai_tenken_report_tenken_data" }
const _hoisted_2 = { class: "col-info" }
const _hoisted_3 = { class: "row1 mb6" }
const _hoisted_4 = { class: "ft-bold" }
const _hoisted_5 = { class: "ib val" }
const _hoisted_6 = { class: "ib val ml6" }
const _hoisted_7 = { class: "move-buttons mt2" }
const _hoisted_8 = { class: "row2" }
const _hoisted_9 = { class: "val" }
const _hoisted_10 = { class: "val" }
const _hoisted_11 = { class: "row3 mb6" }
const _hoisted_12 = { class: "ib val" }
const _hoisted_13 = { class: "row4 mb6" }
const _hoisted_14 = { class: "image-preview-area" }
const _hoisted_15 = {
  key: 0,
  class: "image-box"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "buttons ta-right mr8"
}

import {
  onMounted,
  watch,
  computed,
  reactive,
} from 'vue';
import extJunkaiTenkenReportTenkenDataApi from 'src/apis/extJunkaiTenkenReportTenkenData';
import type { MapElemInfo } from 'src/models';
import useMapElemInfoImagePreview from 'src/composables/useMapElemInfoImagePreview';
import { dtFormat } from 'src/lib/dateHelper';
import type { GITenkenData } from 'src/models/geoItem';

interface MapElemInfoJunkaiTenkenReportTenkenDataState {
  tenkenData: GITenkenData;
}

interface Props {
  elem: MapElemInfo<GITenkenData>;
}

const iconPath = '/static/img/junkai_tenken_report_pin.png';

export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemInfoJunkaiTenkenReportTenkenData',
  props: {
    elem: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<MapElemInfoJunkaiTenkenReportTenkenDataState>({
  tenkenData: props.elem.data,
});
const skipFetchingImage = computed<boolean>(() => {
  return !state.tenkenData?.photoIds || state.tenkenData.photoIds.length === 0;
});
const landmarkDisp = computed<string>(() => [
  state.tenkenData.roadName,
  state.tenkenData.direction,
  state.tenkenData.placeName,
  state.tenkenData.landmarkNumber,
].filter(e => !!e).join(' '));
const modalTitle = computed<string>(() => `${state.tenkenData.inspectionDate} ${state.tenkenData.inspectionTime} - ${landmarkDisp.value}`);
const downloadFilenameTemplate = computed<string>(() => {
  const tenkenDataTs = dtFormat(state.tenkenData.inspectionDate, 'yyyymmddHHMMSS');
  return `${state.tenkenData.id}_${tenkenDataTs}_$TIMESTAMP.jpg`;
});
const { showPrevious, showNext, savedImage, showImage } = useMapElemInfoImagePreview({
  emit,
  elem: computed(() => props.elem),
  refMapElemInfoData: computed(() => state.tenkenData),
  skipFetchingImage,
  fetchApiFn: () => {
    // photoIdsから最初の1件のみ画面に表示する
    return extJunkaiTenkenReportTenkenDataApi.getImage(state.tenkenData.photoIds[0]);
  },
  modalTitle,
  downloadFilenameTemplate,
});

const initDisplay = () => {
  state.tenkenData = props.elem.data;
};

onMounted(initDisplay);

watch(() => props.elem, initDisplay);

const openJunkaiTenkenReport = () => {
  window.open(state.tenkenData.tenkenDataLink, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "col-icon" }, [
      _createElementVNode("img", {
        class: "resource-icon",
        src: iconPath
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ib lbl" }, "点検日時: ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(state.tenkenData.inspectionDate), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(state.tenkenData.inspectionTime), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-xs mr4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showPrevious) && _unref(showPrevious)(...args)))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
            _createTextVNode(" 前へ ", -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-primary btn-xs",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(showNext) && _unref(showNext)(...args)))
          }, [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" 次へ ", -1),
            _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "lbl" }, "点検区分: ", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(state.tenkenData.inspectionType), 1),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "lbl ml12" }, "判定: ", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(state.tenkenData.damageRank), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ib lbl" }, "場所: ", -1)),
          _createElementVNode("span", _hoisted_12, _toDisplayString(landmarkDisp.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_unref(savedImage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: _unref(savedImage),
                  class: "image",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(showImage) && _unref(showImage)(...args)))
                }, null, 8, _hoisted_16)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!!state.tenkenData.tenkenDataLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-info",
                onClick: openJunkaiTenkenReport
              }, " 巡回点検報告書を開く ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})